import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="header-wrapper">
      <div className="header-container">
        <div className="header-logo">
          <a href="/" className="logo-link">My Learning Academy</a>
        </div>
      </div>
      
      <div className="mobile-menu-text">
        Mobile - Click on the hamburger lines below
      </div>
      
      <nav className="main-nav">
        <div className="nav-menu">
          <a href="#" className="nav-item">
            <span>Career Quest Game</span>
          </a>
          <a href="#" className="nav-item">
            <span>Real Facts</span>
          </a>
          <a href="#" className="nav-item">
            <span>Better Animal Behavior</span>
          </a>
          <a href="#" className="nav-item">
            <span>Nature's Signs</span>
          </a>
          <a href="#" className="nav-item">
            <span>Tutoring</span>
          </a>
          <a href="#" className="nav-item">
            <span>About Us</span>
          </a>
          <a href="#" className="nav-item">
            <span>Prices</span>
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Header;
